// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__2VPRx","loader":"Loader_loader__NfYjz","spin":"Loader_spin__R95yB"};